<template>
    <b-card
        no-body
    >
        <div class="card-header">
            <div
                class="card-group-title"
            >
                <h4>Daily Trends</h4>
            </div>
        </div>
        <div
            class="card-body"
        >
            <!-- <p
                v-if="noData"
                class="text-center"
            >
                {{ $t("org.message.No Data") }}
            </p> -->
            <LineChart
                :data=chartData
                :options=chartOptions
                :height=350
            >
            </LineChart>
            <template
                v-if="!isLoading && costOfAfterThisMonth > 0"
            >
                <p
                    class="text-right mr-1 mt-0 mb-1"
                    :style="{'color': themeColors.warning }"
                >
                    <small>
                        * {{ $t('org.billing.costNotExpressedInGraph').replace('{cost}', $_getDollar(costOfAfterThisMonth).replace(' ','')) }}
                    </small>
                </p>
            </template>
        </div>
    </b-card>
</template>

<script>
import CreateVueChart from '@/components/CreateVueChart.js'

export default {
    components: {
        LineChart: CreateVueChart('Line')
    },
    props: {
        xKey: {
            type: String,
            default: ''
        },
        yKeys: {
            type: Array,
            default: function () {
                return []
            }
        },
        lineChartData: {
            type: Array,
            default: function () {
                return []
            }
        },
        pieChartData: {
            type: Array,
            default: function () {
                return []
            }
        },
        month: {
            type: String
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        theme: {
            type: String
        },
        themeColors: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    computed: {
        chartData () {
            return {
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }
                },
                labels: this.dataOfThisMonth.map(item => item.date),
                datasets: this.yKeys.map((label, idx) => {
                    const data = this.dataOfThisMonth.map(item => item[label])
                    const colorOption = ['primary', 'info', 'success', 'warning', 'danger']
                    return {
                        label,
                        data,
                        lineTension: 0,
                        backgroundColor: this.transparentize(this.themeColors[colorOption[idx]], 0.1),
                        borderColor: this.themeColors[colorOption[idx]],
                        borderWidth: 1,
                        pointRadius: 3,
                        line: 1,
                        pointBorderWidth: 2,
                        pointHoverBorderWidth: 2,
                        pointBorderColor: this.themeColors[colorOption[idx]],
                        pointHoverBorderColor: this.themeColors[colorOption[idx]],
                        pointBackgroundColor: this.themeColors.light,
                        pointHoverBackgroundColor: this.themeColors[colorOption[idx]]
                    }
                })
            }
        },
        chartOptions () {
            return {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
                plugins: {
                    datalabels: {
                        display: false
                    },
                    noDataBackground: {
                        display: true,
                        imageSrc: require('@/assets/images/no-data.png'),
                        text: this.$t('org.message.No Data')
                    }
                },
                tooltips: {
                    mode: 'index',
                    shadowOffsetX: 1,
                    shadowOffsetY: 1,
                    shadowBlur: 8,
                    callbacks: {
                        beforeTitle: (tooltipItem) => {
                            return this.dataOfThisMonth[tooltipItem[0].index].date
                        },
                        title: (tooltipItem) => {
                            const data = this.dataOfThisMonth[tooltipItem[0].index]
                            const sum = Object.values(data).filter(value => typeof value === 'number').reduce((acc, cur) => acc + cur)
                            return `Total : ${this.$_getDollar(sum, 2)}`
                        },
                        label: (tooltipItem, data) => {
                            const dataName = data.datasets[tooltipItem.datasetIndex].label
                            const dataValue = this.$_getDollar(this.dataOfThisMonth[tooltipItem.index][dataName], 2)
                            return ` ${dataName} : ${dataValue}`
                        }
                    }
                },
                scales: {
                    xAxes: [
                        {
                            display: true,
                            scaleLabel: {
                                display: true
                            },
                            type: 'time',
                            time: {
                                unit: 'day',
                                stepSize: 5
                            }
                        }
                    ],
                    yAxes: [
                        {
                            stacked: true,
                            display: true,
                            ticks: {
                                beginAtZero: true,
                                count: 5,
                                maxTicksLimit: 5,
                                callback: this.getYData
                            },
                            scaleLabel: {
                                display: true
                            }
                        }
                    ]
                }
            }
        },
        noData () {
            return !this.lineChartData.length && !this.pieChartData.length
        },
        dataOfThisMonth () {
            return this.lineChartData.filter(item => item.date.indexOf(this.month) > -1)
        },
        costOfAfterThisMonth () {
            return this.lineChartData.filter(item => item.date.indexOf(this.month) < 0).reduce((accumulator, currentValue) => {
                const sum = Object.values(currentValue).reduce((accumulator, currentValue) => {
                    if (typeof currentValue === 'number') {
                        accumulator += currentValue
                    }
                    return accumulator
                }, 0)
                return accumulator + sum
            }, 0)
        }
    },
    methods: {
        getYData (label, index, labels) {
            const yData = label < 1 ? this.$_getDollar(label, 3) : this.$_getDollar(label, 0)
            return yData
        },
        transparentize (value, opacity) {
            const r = parseInt(value.slice(1, 3), 16)
            const g = parseInt(value.slice(3, 5), 16)
            const b = parseInt(value.slice(5, 7), 16)
            return `rgba(${r}, ${g}, ${b}, ${opacity})`
        }
    }
}
</script>

<style>

</style>
